function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgArea = function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.281 17.168v3.754a.5.5 0 01-.5.5H2.434v7.229h12.924V27.3a.5.5 0 011 0v1.35h5.31V27.3a.5.5 0 111 0v1.35h7.403V1.538h-7.403v7.9a.5.5 0 11-1 0v-7.9h-9.387v14.63H22.6a.5.5 0 110 1H12.281zm-9.847 3.254h8.847V1.538H2.434v5.246h.435a.5.5 0 110 1H1a.5.5 0 110-1h.434V1.038a.5.5 0 01.5-.5h28.637a.5.5 0 01.5.5v28.113a.5.5 0 01-.5.5h-7.903V31a.5.5 0 01-1 0v-1.35h-5.31V31a.5.5 0 11-1 0v-1.35H1.934a.5.5 0 01-.5-.5V15.61H1a.5.5 0 110-1h.813a.501.501 0 01.243 0h.813a.5.5 0 110 1h-.435v4.812z"
  }));
};

SvgArea.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgArea.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgArea;